import { Page } from "@alpacahq/ui/old";

import { OrdersTable } from "./OrdersTable";

export const Orders = () => {
  return (
    <Page
      title="Orders"
      subtitle="View and manage your orders."
      className="p-8 pt-0 xs:pl-0 md:p-8 md:pt-0 md:pl-0"
    >
      <OrdersTable persistenceKey="/account/orders" />
    </Page>
  );
};

export default Orders;
